/*
 * $Id:: appModel.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { call, put, takeLatest, all, select } from 'redux-saga/effects';

import { me as meSlice } from '../pages/AuthenticatedPage/authenticationSlice';
import { getLocale, setLocale, setLoginUrl, setLogoutUrl } from '../providers';
import { queryLiterals, queryCountries, queryGlobals } from './appService';
import { LITERALS_SLICE_NAME, GLOBALS_SLICE_NAME } from './constants';

function* getGlobals(action) {
    yield put({ type: `${GLOBALS_SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${GLOBALS_SLICE_NAME}/error`, payload: false });
    const response = yield call(queryGlobals, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        const { supportedLanguages, ipo } = response;
        setLoginUrl((ipo || {})['login.redirect.url']);
        setLogoutUrl((ipo || {})['logout.url']);
        const user = select(meSlice);
        let myStorage = window.sessionStorage;
        let userLang = myStorage.getItem('lang');
        setLocale(userLang ? userLang : user && user.language ? user.language : Object.keys(supportedLanguages)[1]);
        const literalsLanguage = userLang ? userLang : user && user.language ? user.language : Object.keys(supportedLanguages)[1];
        yield all([
            yield put({ type: `${GLOBALS_SLICE_NAME}/globals`, payload: response }),
            yield put({ type: `${LITERALS_SLICE_NAME}/fetchLiterals`, payload: { language: literalsLanguage } }),
        ]);
    } else {
        yield put({
            type: `${GLOBALS_SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${GLOBALS_SLICE_NAME}/loading`, payload: false });
}

function* fetchGlobals() {
    yield takeLatest(`${GLOBALS_SLICE_NAME}/fetchGlobals`, getGlobals);
}

function* getLiterals(action) {
    const locale = getLocale();
    if (action.language !== locale) {
        yield put({ type: `${LITERALS_SLICE_NAME}/loading`, payload: true });
        yield put({ type: `${LITERALS_SLICE_NAME}/error`, payload: false });
        const response = yield call(queryLiterals, action.payload);
        if (typeof response === 'object' && response.error === undefined) {
            yield put({
                type: `${LITERALS_SLICE_NAME}/literals`,
                payload: response,
            });
        } else {
            yield put({
                type: `${LITERALS_SLICE_NAME}/error`,
                payload: response.error,
            });
        }
        yield put({ type: `${LITERALS_SLICE_NAME}/loading`, payload: false });
    }
}

function* fetchLiterals() {
    yield takeLatest(`${LITERALS_SLICE_NAME}/fetchLiterals`, getLiterals);
}

function* getCountries(action) {
    yield put({ type: `${GLOBALS_SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${GLOBALS_SLICE_NAME}/error`, payload: false });
    const response = yield call(queryCountries, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield all([
            yield put({ type: `${GLOBALS_SLICE_NAME}/setCountries`, payload: response.country }),
            yield put({ type: `${GLOBALS_SLICE_NAME}/setStates`, payload: response.states.country }),
        ]);
    } else {
        yield put({
            type: `${GLOBALS_SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${GLOBALS_SLICE_NAME}/loading`, payload: false });
}

function* fetchCountries() {
    yield takeLatest(`${GLOBALS_SLICE_NAME}/fetchCountries`, getCountries);
}

export { fetchLiterals, fetchCountries, fetchGlobals };
